import type { LaborDomain } from "@/lib/labor/laborTarget";

/** Domain for `endLaborSession` / `startLaborSession` from a `labor.device_session.page` value. */
export function laborDomainFromSessionPage(page: string): LaborDomain {
  const trimmed = page.trim().toLowerCase();
  if (trimmed.startsWith("clamp-qc")) {
    return "clampqc";
  }
  if (
    trimmed.startsWith("pre-pack")
    || trimmed.startsWith("transfer-pack")
    || trimmed.startsWith("receiving-job:")
    || trimmed === "shipping-team"
  ) {
    return "shipping";
  }
  if (
    trimmed === "final-qc" ||
    trimmed === "pre-encapsulation" ||
    trimmed === "encapsulation" ||
    trimmed.startsWith("encapsulation-job:") ||
    trimmed === "config" ||
    trimmed.startsWith("config-job:") ||
    trimmed === "assembly" ||
    trimmed.startsWith("assembly-job:") ||
    trimmed === "kitting" ||
    trimmed === "cal+test"
  ) {
    return "manufacturing";
  }
  return "clampqc";
}
